<template>
    <div class="notices-table">
        <div class="table-wrap">
            <table class="table table--default" v-if="notificationData.length">
                <tbody class="table__body">
                    <template v-for="(notice, index) in notificationData" :key="notice.id" >
                        <tr class="table__row" :class="{'table__row--green': this.getUserNotice - 1 === index}">
                            <td class="table__col">
                                <span class="table__col-label">Дата</span>
                                <span class="table__col-cont">{{ notice.dateTimeSend }}</span>
                            </td>
                            <td class="table__col">
                                <span class="table__col-label">Поставщик</span>
                                <span class="table__col-cont table__col-cont--green">
                                    <button @click.prevent="handleOpenSupplier(notice.initiator.id)">
                                        <b>{{ notice.initiator.name }} {{ notice.initiator.lastName }}</b>
                                    </button>
                                </span>
                            </td>
                            <td class="table__col">
                                <span class="table__col-label">Категория</span>
                                <span class="table__col-cont">
                                    <span class="status status--mini" :data-status="notice.type.name">{{ notice.type.name }}</span>
                                </span>
                            </td>
                            <td class="table__col nowrap">
                                <span class="table__col-label">Подробности</span>
                                <span class="table__col-cont table__col-cont--green">
                                    <button @click="showNotificationPopup(notice.info.productGroups)">
                                        <b>Подробнее</b>
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr class="table__margin">
                            <td colspan="100%"></td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <div v-else class="table-card__empty">Уведомлений не найдено</div>
        </div>
        <transition-group name="modal">
            <SupplierPopup v-if="ShowSupplierPopup" :supplier="selectedSupplier" :canEdit="false" @close="ShowSupplierPopup = false"/>
            <NotificationsCatPopup v-if="ShowNotificationsCatPopup" @close="ShowNotificationsCatPopup = false" :product-groups="productGroups"/>
        </transition-group>
    </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import SupplierPopup from "@/components/sections/Suppliers/SupplierPopup.vue";
import NotificationsCatPopup from "@/components/sections/Notifications/NotificationsCatPopup.vue";
export default {
	name: "NotificationsTable",
	components: {SupplierPopup, NotificationsCatPopup},
    props: {
        notificationData: {
            type: Array,
            default: () => []
        }    
    },
    data() {
        return {
            ShowSupplierPopup: false,
            ShowNotificationsCatPopup: false,
            selectedSupplier: null,
            productGroups: [],
        }
    },
	methods: {
        async handleOpenSupplier(id = "") {
            if (!id) return
            const res = await this.requestSupplier(id);
        
            if (res.success) {
                this.selectedSupplier = res.data;
                this.ShowSupplierPopup = true;
            }
        },
        showNotificationPopup(productGroups) {
            this.productGroups = productGroups
            this.ShowNotificationsCatPopup = true
        },
        ...mapActions({
			requestSupplier: 'suppliers/requestSupplier',
		})
	},
	computed: {
		...mapGetters({
            checkUserRole: 'user/checkUserRole',
            getUserNotice: 'user/getUserNotice',
		})
	}
}
</script>


